import React from 'react';

export const ErrorPage = () => {
  return <h1>Page not found</h1>;
};
